import { gql } from "@apollo/client";
import { AnimalGroupInfo } from "./getAnimalGroupCall";


export const CREATE_ANIMAL_GROUPS = gql`
  mutation CreateAnimalGroup($domain: String!, $names: [String!]!) {
    animalGroup {
      create(domain: $domain, names: $names) {
        name
        animal_group_id
        animalsCount(domain: $domain)
      }
    }
  }
`

export interface CreateAnimalGroupResponse {
  animalGroup: {
    create: AnimalGroupInfo[]
  }
}